export const CONSENT_COOKIE = 'cookie_consents';
export const TRACKING_EVENT = 'GAEvent';
